import './index.css';
import { Button, Form, DatePicker, message } from 'antd';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { actionExportStatistics } from '../../../core/actions/scanner/export-data';

const { RangePicker } = DatePicker;

const ExportTaskList = () => {
    const { i18n } = useTranslation();
    const dispatch = useDispatch();

    const handleExport = (values: any) => {
        const { userId, timeRange } = values;

        if (!userId && (!timeRange || timeRange.length !== 2)) {
            message.warning(i18n?.t('selectUserOrTimeRange') || '请选择用户或时间范围', 3);
            return;
        }

        const exportData = {
            start_time: '',
            end_time: '',
        };

        if (timeRange && timeRange.length === 2) {
            exportData.start_time = timeRange[0].startOf('day').toISOString();
            exportData.end_time = timeRange[1].endOf('day').toISOString();
        }

        dispatch(actionExportStatistics(exportData) as any);
    };

    return (
        <div className="export-task-list model">
            <h3 className="margin-bottom-12">{i18n?.t('exportStatistics') || '导出门店统计数据'}</h3>

            <div className="export-function-area">
                <div className="export-form-container">
                    <Form
                        layout="inline"
                        onFinish={handleExport}
                        style={{ width: '100%', justifyContent: 'space-between' }}
                    >
                        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                            <Form.Item
                                name="timeRange"
                                label={i18n?.t('timeRange') || '时间范围'}
                                style={{ marginBottom: 0 }}
                            >
                                <RangePicker
                                    style={{ width: 300 }}
                                    format="YYYY-MM-DD"
                                    placeholder={[
                                        i18n?.t('startDate') || '开始日期',
                                        i18n?.t('endDate') || '结束日期'
                                    ]}
                                />
                            </Form.Item>
                        </div>

                        <Form.Item style={{ marginBottom: 0 }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                            >
                                {i18n?.t('export') || '导出'}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default ExportTaskList;
